import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import moment from "moment";
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createMagazine,
  updateMagazine,
  deleteMagazine,
  getMagazine,
  getMagazineList } from '../../../services/MagazineService'


function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class MagazinePageList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      currentUser: null,
      isLoading: true,
      dataList: []
    };

  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    let dataList = await getMagazineList();
    /*
    log.debug(dataList.length)
    dataList.forEach(function(doc) {
        log.debug(doc.id, " => ", doc.data());
    });
    */

    log.debug('all data is loaded.')
    this.setState({dataList: dataList})
    this.setState({isLoading: false})
  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
          <h4 className="page-header">
          <Link to='/magazine'>Magazine</Link> ->
          List
        </h4>
          <table className="table">
              <thead>
                  <tr>
                      <th>magazine_id</th>
                      {/* <th>magazine_uuid</th>
                      <th>publisher_id</th>
                      <th>owner_id</th> */}
                      <th>tag</th>
                      <th>title</th>
                      {/* <th>description</th> */}
                      {/* <th>latest_issue_id</th> */}
                      <th>is_publish</th>
                      {/* <th>sort_order</th>
                      <th>share_text</th>
                      <th>embed_html</th> */}
                      <th>date_created</th>
                      <th>status</th>
                      <th> Actions </th>
                  </tr>
              </thead>
              <tbody>
                {
                  this.state.dataList.map((data, index) =>
                  <tr key={index}>
                    <td>{data.id}</td>

                      {/* <td>{data.data().magazine_uuid} </td>
                      <td>{data.data().publisher_id} </td>
                      <td>{data.data().owner_id} </td> */}
                      <td>{data.data().tag} </td>
                      <td>{data.data().title} </td>
                      {/* <td>{data.data().description} </td>
                      <td>{data.data().latest_issue_id} </td> */}
                      <td>{data.data().is_publish} </td>
                      {/* <td>{data.data().sort_order} </td>
                      <td>{data.data().share_text} </td>
                      <td>{data.data().embed_html} </td> */}
                      <td>{moment(data.data().date_created).fromNow()} </td>
                      <td>{data.data().status} </td>
                    {/* <td>{moment(data.data().date_created).fromNow()}</td> */}
                    <td>
                      <Link className="btn btn-small btn-primary" to={`/magazine/view/${data.id}`}>view</Link>
                    </td>
                  </tr>
                )
                }
              </tbody>
          </table>
          {/* <p>
              <Link className="btn btn-success" to='/magazine/add'>Add New Magazine</Link>
          </p> */}
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/MagazinePage/MagazinePageList.js